import _      from 'lodash'
import moment from 'moment'

import Model from 'alto-orm/lib/orm/model'

import { dateFormat } from 'alto-utils/lib/utils'

class Meal extends Model
  # attrs: name (string), description (string), canteen (fkey), course (string fkey), date (date),
  #        number (positive smallint), showOnWeb (bool, default true),
  #        stockCardNumber (positive int), additionalCourse (string fkey, nullable),
  #        additionalCourseDefaultNumber (positive smallint, nullable)

  @nominativeName: 'jídlo'
  @accusativeName: 'jídlo'

  @attrNameMapping:
    canteenID:            'canteen'
    courseName:           'course'
    additionalCourseName: 'additional_course'

  @serialize: (meal) ->
    _.assign(super(meal), date: meal.date.format(dateFormat))

  @deserialize: (row) ->
    super(row).with(date: moment(row.date, dateFormat))

  hasAdditional: ->
    @additionalCourseName?

export default Meal
